import { Grid, Stack, Typography } from "@mui/material";

export default function BookingSection(props) {
  return (
    <Stack sx={{ width: "100%", alignItems: "stretch", paddingX: "5%" }}>
      <Typography variant="h3">{props.title}</Typography>
      {/* <Stack spacing={4} sx={{ width: "100%", alignItems: "stretch", paddingX: 10, pt: 2, pb: 3}}>
        {props.children}
      </Stack> */}
      <Grid
        container
        spacing={4}
        columns={props.fullSize ? { xs: 12, lg: 6 } : 12}
        sx={{
          alignItems: props.center ? "center" : "flex-start",
          // Matches the former GridLegacy layout, whose negative margin shifted the
          // 100%-wide container left by the spacing and narrowed its items.
          width: theme => `calc(100% - ${theme.spacing(4)})`,
          paddingX: "5%",
          pt: 2,
          pb: 3
        }}>
        {props.children}
      </Grid>
    </Stack>
  );
}